import _ from "lodash";
import { openAlert } from "../components/Modal/MsgBox";

export const pwPattern =
  /^(?=.*[a-zA-Z])(?=.*[!@#$%^*.+=-])(?=.*[0-9]).{8,25}$/;
export const emailPattern =
  /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
export const phonePattern = /^01([016789])-?([0-9]{3,4})-?([0-9]{4})$/;
export const namePattern = /^[가-힣a-zA-Z ]*$/;
export const workerIdPattern = /^([.0-9a-zA-Z_+\-@]*)$/;

export const validateEmail = (email, type = "") => {
  // 입력 완료 후 fetch 전 체크
  if (isBlankStr(email)) {
    openAlert(
      `${type === "loginId" ? "아이디(이메일)" : "이메일"}을 입력해주세요.`,
    );
    return false;
  } else if (!emailPattern.test(email)) {
    openAlert("이메일 형식이 잘못되었습니다.");
    return false;
  }
  return true;
};

export const validatePhone = (phone) => {
  // 입력 완료 후 fetch 전 체크
  if (isBlankStr(phone)) {
    openAlert("휴대폰번호를 입력해주세요.");
    return false;
  } else if (!phonePattern.test(phone)) {
    openAlert("휴대폰 번호를 정확히 입력해 주세요.");
    return false;
  }
  return true;
};

export const validateName = (name) => {
  // 입력 완료 후 fetch 전 체크
  if (isBlankStr(name)) {
    openAlert("이름을 입력해주세요.");
    return false;
  } else if (!namePattern.test(name.trim())) {
    openAlert("이름 형식이 잘못되었습니다.");
    return false;
  }
  return true;
};

export const validatePassword = (pw, cpw) => {
  if (!pw) {
    openAlert("새 비밀번호를 입력해주세요.");
    return false;
  } else if (!cpw) {
    openAlert("새 비밀번호 확인을 입력해주세요.");
    return false;
  } else if (pw !== cpw) {
    openAlert("비밀번호가 일치하지 않습니다.");
    return false;
  } else if (!pwPattern.test(pw)) {
    openAlert(
      "새비밀번호를 영문, 숫자, 특수 문자를 사용하여 8자 이상으로 입력해주세요.",
    );
    return false;
  }
  return true;
};

export const validatePwPattern = (pw) => {
  if (!pwPattern.test(pw)) {
    openAlert("영문, 숫자, 특수 문자를 사용하여 8자 이상으로 입력해주세요.");
    return false;
  }
  return true;
};

export const isBlankStr = (str) => {
  return str === undefined || str === null || str.trim().length === 0;
};

export const validateStr = (str, msg) => {
  if (isBlankStr(str)) {
    openAlert(msg + " 입력해 주세요.\n");
    return false;
  }
  return true;
};

export const handlePhone = (str) => {
  // 전화번호 입력 시 hypen 추가
  let phone = str.replace(/[^0-9]/g, "");
  let tmp = "";

  if (_.isEqual(phone.substring(0, 2), "02")) {
    if (phone.length < 3) {
      return str;
    } else if (phone.length < 6) {
      tmp += phone.substr(0, 2);
      tmp += "-";
      tmp += phone.substr(2);
      return tmp;
    } else if (phone.length < 10) {
      tmp += phone.substr(0, 2);
      tmp += "-";
      tmp += phone.substr(2, 3);
      tmp += "-";
      tmp += phone.substr(5);
      return tmp;
    } else {
      tmp += phone.substr(0, 2);
      tmp += "-";
      tmp += phone.substr(2, 4);
      tmp += "-";
      tmp += phone.substr(6, 4);
      return tmp;
    }
  } else {
    if (phone.length < 4) {
      return str;
    } else if (phone.length < 7) {
      tmp += phone.substr(0, 3);
      tmp += "-";
      tmp += phone.substr(3);
      return tmp;
    } else if (phone.length < 11) {
      tmp += phone.substr(0, 3);
      tmp += "-";
      tmp += phone.substr(3, 3);
      tmp += "-";
      tmp += phone.substr(6);
      return tmp;
    } else {
      tmp += phone.substr(0, 3);
      tmp += "-";
      tmp += phone.substr(3, 4);
      tmp += "-";
      tmp += phone.substr(7);
      return tmp;
    }
  }
};

export const handleVerificationCode = (value) => {
  return value.replace(/[^0-9]/g, "");
};

export const handleExpense = (str) => {
  if (isBlankStr(str)) return "";
  const expense = str.replace(/[^0-9]/g, "");
  return expense;
};

export function numberToKr(won) {
  if (won === 0) return "0원";

  const units = [
    { value: 1_0000_0000_0000, label: "조" },
    { value: 1_0000_0000, label: "억" },
    { value: 1_0000, label: "만" },
    { value: 1_000, label: "천" },
  ];

  let result = [];
  let remain = won;

  for (const unit of units) {
    const amount = Math.floor(remain / unit.value);
    if (amount > 0) {
      result.push(`${amount}${unit.label}`);
      remain %= unit.value;
    }
  }

  if (remain > 0) {
    result.push(`${remain}`);
  }

  return result.join(" ") + "원";
}
